// extracted by mini-css-extract-plugin
export default {"pdf":"fe891bd5"};